import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const MESSAGES = {
  ROOT: `${PRIVATE_ROOT}/messages`,
  INBOX: `${PRIVATE_ROOT}/messages/inbox`,
  SENT: `${PRIVATE_ROOT}/messages/sent`,
  VIEW: `${PRIVATE_ROOT}/messages/view/:id`,
  REPLY: `${PRIVATE_ROOT}/messages/view/:id/reply`,
  SEND_MESSAGE: `${PRIVATE_ROOT}/messages/send-message`,
  CONTACT_INFO: `${PRIVATE_ROOT}/contact-info`,
}
